import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { getRemoteConfigValue } from "@tv4/avod-web-player-common";
import { getRemainingAdImmunity } from "@tv4/avod-web-player-core";
import ChromeCastConnectedIconSvg from "../icons/ChromeCastConnectedIcon.svg";
import ChromeCastDisconnectedIconSvg from "../icons/ChromeCastDisconnectedIcon.svg";
import { useAccessToken } from "../providers/AccessTokenContext";
import { useChromecastManager, useOptions, usePlayerState, } from "../providers/CoreProvider";
import { useMetadata } from "../providers/MetadataProvider";
import { useTranslations } from "../providers/TranslationsProvider";
import { PlayerControlButtonComponent } from "./PlayerControlButton";
export const ChromeCastButton = ({ interactive }) => {
    const { asset } = useMetadata();
    const playerState = usePlayerState();
    const { activeAudioTrack, currentTime, isCasting } = playerState;
    const { refreshToken } = useOptions() || {};
    const getAccessToken = useAccessToken();
    const translations = useTranslations();
    const manager = useChromecastManager();
    const castReady = !!manager;
    const startCasting = async () => {
        if (!asset) {
            // TODO: handle src
            console.log("temp error for missing assetId, could be src");
            return;
        }
        const { id: assetId, title } = asset;
        const remainingAdImmunity = getRemainingAdImmunity(assetId, getRemoteConfigValue("AD_IMMUNITY_DURATION"));
        await manager?.cast({
            assetId,
            title,
            currentTime,
            accessToken: getAccessToken(),
            refreshToken,
            remainingAdImmunity,
            preferredAudioLanguage: activeAudioTrack?.language,
        });
    };
    const stopCasting = () => {
        manager?.stop();
    };
    return (_jsxs(_Fragment, { children: [!isCasting && castReady && (_jsx(PlayerControlButtonComponent, { "aria-label": translations("player__a11y__voice_over_start_cast_button"), onClick: startCasting, interactive: interactive, Icon: _jsx(ChromeCastDisconnectedIconSvg, {}), hoverText: translations("player__a11y__hover_label_start_cast_button") })), isCasting && castReady && (_jsx(PlayerControlButtonComponent, { "aria-label": translations("player__a11y__voice_over_stop_cast_button"), onClick: stopCasting, interactive: interactive, Icon: _jsx(ChromeCastConnectedIconSvg, {}), hoverText: translations("player__a11y__hover_label_stop_cast_button") }))] }));
};
export default ChromeCastButton;
